export const TOGGLE_RIBBON = 'TOGGLE_RIBBON'
